// extracted by mini-css-extract-plugin
export default {"empty":"Notice_empty__rb+tX","content":"Notice_content__CwvEF"};